module.exports = __webpack_public_path__ + "static/img-servo-motor-1a1104ded059e48dee737baf0a8d5b23.jpg";